import React, { useState, useRef } from "react";
import "./orderFilter.css";

const OrderFilter = ({ setQuery }) => {
  const [filterOrder, setFilterOrder] = useState({
    searchFields: "",
    startDate: "",
    endDate: "",
  });
  
  const filterRef = useRef(filterOrder);
  filterRef.current = filterOrder;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterOrder(prev => ({ ...prev, [name]: value }));
  };

  const handleFilter = () => {
    setQuery({ ...filterRef.current });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleFilter();
    }
  };

  const clearFilter = () => {
    const clearedFilter = {
      searchFields: "",
      startDate: "",
      endDate: "",
    };
    setFilterOrder(clearedFilter);
    setQuery(clearedFilter);
  };

  return (
    <div className="of-container">
      <div className="of-main-row">
        <div className="of-search-wrapper">
          <svg className="of-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
          </svg>
          <input
            type="text"
            className="of-search-input"
            placeholder="Search Order ID, Name..."
            value={filterOrder.searchFields}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            name="searchFields"
          />
          {filterOrder.searchFields && (
            <button 
              className="of-search-clear" 
              onClick={() => {
                const newFilter = { ...filterOrder, searchFields: "" };
                setFilterOrder(newFilter);
              }}
              type="button"
            >
              ×
            </button>
          )}
        </div>

        <div className="of-date-wrapper">
          <div className="of-date-field">
            <label>From</label>
            <input
              type="date"
              value={filterOrder.startDate}
              onChange={handleChange}
              name="startDate"
            />
          </div>
          <span className="of-date-sep">–</span>
          <div className="of-date-field">
            <label>To</label>
            <input
              type="date"
              value={filterOrder.endDate}
              onChange={handleChange}
              name="endDate"
            />
          </div>
        </div>

        <button className="of-btn-search" onClick={handleFilter} type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
          </svg>
          Search
        </button>

        {(filterOrder.searchFields || filterOrder.startDate || filterOrder.endDate) && (
          <button className="of-btn-clear" onClick={clearFilter} type="button">
            Clear
          </button>
        )}
      </div>
    </div>
  );
};

export default OrderFilter;

